import { useCallback, useMemo, useState } from 'react';
import { useDisclosure } from '@mantine/hooks';

import type { ConfirmationModalPayload } from '../types';

const useConfirmationModal = () => {
  const [isOpen, { open, close }] = useDisclosure(false);
  const [payload, setPayload] = useState<ConfirmationModalPayload>({});

  const handleSetIsOpen = useCallback(
    (props: { isOpen: false } | { isOpen: true; payload: ConfirmationModalPayload }) => {
      if (props.isOpen) {
        setPayload(props.payload);
        open();
        return;
      }
      close();
    },
    [close, open]
  );

  const contextValue = useMemo(
    () => ({
      isOpen,
      payload,
      setIsOpen: handleSetIsOpen,
      setRemainingTime: (time: string) => setPayload((p) => ({ ...p, remainingTime: time })),
      setOnConfirmLoading: (isLoading: boolean) =>
        setPayload((p) => ({ ...p, isOnConfirmLoading: isLoading })),
    }),
    [handleSetIsOpen, isOpen, payload]
  );

  return contextValue;
};

export default useConfirmationModal;
